module.exports = __webpack_public_path__ + "static/day1-cf49fb9eb45cd1d32c324bf4edbb9eb4.webm";